const exchange = {
  title: "Tauschbörse",
  allDay: "Ganztägig",
  view: {
    others: "Anfragen von anderen",
    mine: "Meine Anfragen",
    toggleAriaLabel: "Ansicht der Tauschbörse wählen",
  },
  filter: {
    allCounselors: "Alle Berater:innen",
    counselorAriaLabel: "Nach Berater:in filtern",
  },
  columns: {
    date: "Datum",
    time: "Uhrzeit",
    location: "Ort",
    createdAt: "Erstellt am",
    from: "Von",
    service: "Dienst",
    requested: "Gesucht",
    offers: "Angebote",
    action: "Aktion",
  },
  requested: {
    prefix: "gegen",
    or: "oder",
  },
  buttons: {
    history: "Geschichte",
    newRequest: "Neue Anfrage",
  },
  actions: {
    makeOffer: "Angebot abgeben",
    withdrawOffer: "Angebot zurückziehen",
    deleteRequest: "Anfrage löschen",
    viewOffers: "Angebote ansehen",
    // Names the request the count belongs to: the visible number is the button's only content, and an
    // aria-label replaces it, so the label has to carry both the count and which row it sits in.
    viewOffersAriaLabel_one: "{{count}} Angebot zur Anfrage vom {{appointment}} ansehen",
    viewOffersAriaLabel_other: "{{count}} Angebote zur Anfrage vom {{appointment}} ansehen",
  },
  offersDialog: {
    title: "Angebote zur Tauschanfrage",
    ownService: "Eigener Dienst:",
    requested: "gesucht: {{requested}}",
    loading: "Angebote werden geladen",
    loadError: "Die Angebote konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    empty: "Zu dieser Anfrage liegen keine Angebote vor.",
    processedSection: "Erledigt",
    note: "„{{note}}“",
    appointmentMissing: "Der angebotene Dienst existiert nicht mehr.",
    acceptOffer: "Tausch annehmen",
    rejectOffer: "Ablehnen",
    acceptOfferAriaLabel: "Tausch mit {{counselor}} annehmen",
    rejectOfferAriaLabel: "Angebot von {{counselor}} ablehnen",
    offerStatus: {
      accepted: "Getauscht",
      rejected: "Abgelehnt",
    },
    acceptSuccessMessage: "Der Tausch wurde angenommen.",
    rejectSuccessMessage: "Das Angebot wurde abgelehnt.",
  },
  deleteRequestDialog: {
    title: "Tauschanfrage löschen?",
    text: "Ihre Anfrage für {{appointment}} · {{purpose}} wird gelöscht. Bereits eingegangene Angebote entfallen.",
    confirm: "Löschen",
    successMessage: "Die Tauschanfrage wurde gelöscht.",
  },
  // Read by the shared ExchangeableAppointmentPicker and by both dialogs' schemas.
  picker: {
    selectDatesHint: "Bitte „Datum von“ und „Datum bis“ wählen, um die eigenen Dienste anzuzeigen.",
    loading: "Eigene Dienste werden geladen",
    loadError: "Die eigenen Dienste konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    empty: "Keine tauschbaren Dienste im gewählten Zeitraum.",
  },
  requestedServices: {
    section: "Gesuchte Dienste",
    loading: "Dienste werden geladen",
    note: "Notiz",
    notePlaceholder: "z. B. Tausch nur innerhalb KW 31",
  },
  validation: {
    tillBeforeFrom: "„Datum bis“ darf nicht vor „Datum von“ liegen.",
    appointmentRequired: "Bitte einen eigenen Dienst auswählen.",
    purposesRequired: "Bitte mindestens einen gesuchten Dienst auswählen.",
  },
  offerDialog: {
    title: "Angebot abgeben",
    summary: "{{counselor}} sucht Tausch für <bold>{{appointment}} · {{purpose}}</bold> — gesucht: {{requested}}",
    ownServiceSection: "Eigener Dienst",
    from: "Datum von",
    till: "Datum bis",
    onlyRequestedPurposes: "Nur Termine mit gesuchtem Dienst zeigen",
    note: "Notiz",
    notePlaceholder: "z. B. Tausch nur vormittags möglich",
    submit: "Angebot abgeben",
    successMessage: "Das Angebot wurde abgegeben.",
    picker: {
      emptyFiltered:
        "Keine eigenen Dienste mit gesuchtem Dienst im gewählten Zeitraum. Filter deaktivieren oder Zeitraum erweitern.",
    },
  },
  withdrawOfferDialog: {
    title: "Angebot zurückziehen?",
    text: "Ihr Angebot zur Tauschanfrage von {{counselor}} ({{appointment}} · {{purpose}}) wird zurückgezogen.",
    confirm: "Zurückziehen",
    successMessage: "Das Angebot wurde zurückgezogen.",
  },
  newRequestDialog: {
    title: "Neue Tauschanfrage",
    ownServiceSection: "Eigener Dienst",
    from: "Datum von",
    till: "Datum bis",
    submit: "Anfrage einstellen",
    successMessage: "Die Tauschanfrage wurde eingestellt.",
  },
  editRequestDialog: {
    title: "Tauschanfrage bearbeiten",
    successMessage: "Die Tauschanfrage wurde gespeichert.",
  },
  history: {
    title: "Tauschbörse – Geschichte",
    filter: {
      from: "Von",
      till: "Bis",
      givenAwayBy: "Abgegeben von",
      exchangedWith: "Getauscht mit",
    },
    columns: {
      timestamp: "Zeitpunkt",
      givenAwayBy: "Abgegeben von",
      givenAppointment: "Abgegebener Termin",
      givenService: "Abgegebener Dienst",
      exchangedWith: "Getauscht mit",
      receivedAppointment: "Erhaltener Termin",
      receivedService: "Erhaltener Dienst",
    },
    validation: {
      tillBeforeFrom: "„Bis“ darf nicht vor „Von“ liegen.",
    },
  },
};

export default exchange;
